import type { NtfColor, NtfColorKey } from './customSnackbars/DynamicSnackBar/types';
import { NTF_COLOR } from './constants';

export const isValidHex = (hex: string): boolean => {
  return /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex);
};

export const getColorHex = (colorInput?: NtfColor): string => {
  if (!colorInput) return NTF_COLOR.info;
  if (colorInput in NTF_COLOR) return NTF_COLOR[colorInput as NtfColorKey];
  if (isValidHex(colorInput)) return colorInput;
  return NTF_COLOR.info;
};
